import { FC, useMemo } from 'react';
import Select from '../../select';
import { FormProps } from '../../helpers';
import { PolicyModelV1 } from '@/lib/models/policy-model-v1/policy-v1.model';
import { getSensitiveDataActionOptions } from '@/lib/models/policy-model-v1/sensitive-data';
import { getFormattedUiOptions } from '../../select/helpers';

interface Props extends FormProps {
  value: string;
  onChange: (value: string) => void;
  policy: PolicyModelV1;
  orgPolicy?: PolicyModelV1;
}

const SdActionSelectV1: FC<Props> = ({ value, onChange, policy, orgPolicy, ...rest }) => {
  const actionOpts = useMemo(() => {
    const options = getSensitiveDataActionOptions(policy, orgPolicy);
    return getFormattedUiOptions(options);
  }, [policy, orgPolicy]);

  const props = {
    ...rest,
    value,
    onChange,
    options: actionOpts,
    label: 'Action',
  };

  return <Select {...props} size="medium" />;
};

export default SdActionSelectV1;
